import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-563c2de8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown langdropdown" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-globe ms-lg-0 ms-md-0 ms-1" }, null, -1))
const _hoisted_3 = {
  class: "dropdown-menu border-0",
  "aria-labelledby": "lang"
}

import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { userLangStore } from '@/store/userLangStore';
import { userMainStore } from '@/store/userMainStore';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSelector',
  props: {
	top: Boolean,
	colorclass: String,
},
  setup(__props) {

const route = useRoute();
let qlang = null;
if (route.query.lng == 'el') qlang = 'el';

const main = userMainStore();
const langstore = userLangStore();



const t = useI18n();
t.locale.value = qlang || localStorage.getItem('locale') || 'en';
const currentLanguage = ref(t.locale.value);

const setLang = (lang) => {
	currentLanguage.value = lang;
	t.locale.value = lang;
	localStorage.setItem("locale", lang);
	langstore.refreslang = !langstore.refreslang;
	let h = document.querySelector('html');
	h.setAttribute('lang', lang);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass([[ _unref(main).isavailable ? 'homepage' : '', __props.colorclass ? __props.colorclass : '', (__props.top && _unref(main).isavailable) ? '' : '' ], "lang-btn btn btn-sm btn-secondary dropdown-toggle text-uppercase"]),
      type: "button",
      id: "lang",
      "data-bs-offset": "0, 13",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      _hoisted_2,
      _createTextVNode(" " + _toDisplayString(currentLanguage.value), 1)
    ], 2),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setLang('en')))
        }, "EN")
      ]),
      _createElementVNode("li", null, [
        _createElementVNode("a", {
          class: "dropdown-item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setLang('el')))
        }, "ΕΛ")
      ])
    ])
  ]))
}
}

})